import { OfferTypeContainer } from '../../containers/filters/OfferTypeContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const offerType: IOpenableFilter = {
  component: OfferTypeContainer,
  type: EFilterType.Openable,
};
